import {
  OPEN_ESCROW_VIEW,
  CLOSE_ESCROW_VIEW,
  ESCROW_PROCESS_SUCCESS,
  ESCROW_PROCESS_FAILURE,
  ESCROW_PROCESS_STARTED,
  RELEASE_ESCROW_PROCESS_STARTED,
  RELEASE_ESCROW_PROCESS_FAILURE,
  RELEASE_ESCROW_PROCESS_SUCCESS,
  GET_COMPANY_FINANCES_SUCCESS,
  GET_COMPANY_FINANCES_FAILURE,
  UPDATE_COMPANY_BALANCE_SUCCESS,
  UPDATE_COMPANY_BALANCE_FAILURE,
  GET_COMPANY_FINANCES_STARTED,
  PAY_WITH_BALANCE_SUCCESS,
  PAY_WITH_BALANCE_FAILURE
} from '../constants';
import { dealStatuses } from '../../constants';
import axios from 'axios';

export const openEscrowView = deal => {
  return (dispatch, getState) => {
    dispatch({ type: OPEN_ESCROW_VIEW, payload: { deal } });
  };
};

export const closeEscrowView = () => {
  return (dispatch, getState) => {
    dispatch({ type: CLOSE_ESCROW_VIEW });
  };
};

export const acceptContentAndReleaseFunds = (
  paymentId,
  amount,
  influencerId,
  companyUid,
  dealId
) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const firebaseUrl = process.env.REACT_APP_FIREBASE_URL;
    dispatch({ type: RELEASE_ESCROW_PROCESS_STARTED, payload: {} });

    return firestore
      .collection('users')
      .doc(influencerId)
      .get()
      .then(user => {
        const data = user.exists ? user.data() : null;

        if (data && data.paypalInfo && data.paypalInfo.payerId) {
          return firebase
            .auth()
            .currentUser.getIdToken(/* forceRefresh */ true)
            .then(function(idToken) {
              axios
                .post(`${firebaseUrl}/releaseEscrowFunds`, {
                  amount,
                  paymentId,
                  paypalId: data.paypalInfo.payerId,
                  companyId: companyUid,
                  idToken,
                  dealId
                })
                .then(res => {
                  if (res.status === 200 && res.data) {
                    if (res.data.status === 'transfer-success') {
                      // update the deal status
                      firestore
                        .collection('deals')
                        .doc(dealId)
                        .get()
                        .then(dealSnapshot => {
                          dealSnapshot.ref
                            .update({
                              status: dealStatuses.COMPLETE
                            })
                            .then(() => {
                              firestore.collection('dealStatuses').add({
                                dealId,
                                newStatus: dealStatuses.COMPLETE,
                                oldStatus: dealSnapshot.data().status,
                                updater: companyUid,
                                timestamp: firestore.FieldValue.serverTimestamp()
                              });
                            })
                            .then(response => {
                              updateInfluencerCompletedDeals(
                                firestore,
                                influencerId
                              );
                              updateCompanyCompletedDeals(
                                firestore,
                                influencerId
                              );
                              dispatch({
                                type: RELEASE_ESCROW_PROCESS_SUCCESS,
                                payload: {}
                              });
                            });
                        });
                    }
                  } else {
                    dispatch({
                      type: RELEASE_ESCROW_PROCESS_FAILURE,
                      payload: { error: '' }
                    });
                  }
                })
                .catch(error => {
                  dispatch({
                    type: RELEASE_ESCROW_PROCESS_FAILURE,
                    payload: { error }
                  });
                });
            })
            .catch(error => {
              dispatch({
                type: RELEASE_ESCROW_PROCESS_FAILURE,
                payload: { error }
              });
            });
        } else {
          dispatch({
            type: RELEASE_ESCROW_PROCESS_FAILURE,
            payload: { error: 'User does not have Paypal enabled' }
          });
          return { error: 'User does not have Paypal enabled' };
        }
      })
      .catch(error => {
        dispatch({
          type: RELEASE_ESCROW_PROCESS_FAILURE,
          payload: {
            error: error,
            message:
              'There was an issue accessing the user records for escrow payout.'
          }
        });
        return {
          error:
            'There was an issue accessing the user records for escrow payout.'
        };
      });
  };
};

const updateInfluencerCompletedDeals = (firestore, influencerId) => {
  firestore
    .collection('users')
    .doc(influencerId)
    .get()
    .then(userDoc => {
      const user = userDoc.data();
      userDoc.ref.update({
        completedDeals: user.completedDeals ? user.completedDeals + 1 : 1
      });
    });
};

const updateCompanyCompletedDeals = (firestore, companyId) => {
  firestore
    .collection('users')
    .doc(companyId)
    .get()
    .then(userDoc => {
      const user = userDoc.data();
      userDoc.ref.update({
        completedDeals: user.completedDeals ? user.completedDeals + 1 : 1
      });
    });
};

export const processEscrowFunds = (payment, dealId) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    dispatch({ type: ESCROW_PROCESS_STARTED, payload: {} });
    // change status to active

    const fullPayment = {
      ...payment,
      dealId
    };

    firestore
      .add(
        { collection: 'payments' },
        {
          ...fullPayment
        }
      )
      .then(paymentDoc => {
        firestore
          .collection('deals')
          .doc(dealId)
          .get()
          .then(dealSnapshot => {
            dealSnapshot.ref
              .update({
                paymentId: paymentDoc.id,
                status: dealStatuses.ACTIVE
              })
              .then(() => {
                firestore.collection('dealStatuses').add({
                  dealId,
                  newStatus: dealStatuses.ACTIVE,
                  oldStatus: dealSnapshot.data().status,
                  updater: payment.companyId,
                  timestamp: firestore.FieldValue.serverTimestamp()
                });

                dispatch({ type: ESCROW_PROCESS_SUCCESS, payload: {} });
              });
          });
      })
      .catch(err => {
        dispatch({
          type: ESCROW_PROCESS_FAILURE,
          payload: { errorMessage: err.message }
        });
      });
  };
};

export const getCompanyFinances = () => {
  return async (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    // dispatch({
    //   type: GET_COMPANY_FINANCES_STARTED,
    //   payload: {}
    // });

    const idToken = await firebase.auth().currentUser.getIdToken(false);

    return axios
      .post(`${process.env.REACT_APP_FIREBASE_URL}/getCompanyFinancials`, {
        idToken
      })
      .then(response => {
        dispatch({
          type: GET_COMPANY_FINANCES_SUCCESS,
          payload: { ...response.data }
        });

        return response.data;
      })
      .catch(err => {
        dispatch({
          type: GET_COMPANY_FINANCES_FAILURE,
          payload: { err }
        });

        return err;
      });
  };
};

export const updateCompanyBalance = details => {
  return async (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    const idToken = await firebase.auth().currentUser.getIdToken(false);

    return axios
      .post(`${process.env.REACT_APP_FIREBASE_URL}/updateCompanyBalance`, {
        idToken,
        details
      })
      .then(response => {
        dispatch({
          type: UPDATE_COMPANY_BALANCE_SUCCESS,
          payload: { ...response.data }
        });

        return response.data;
      })
      .catch(err => {
        dispatch({
          type: UPDATE_COMPANY_BALANCE_FAILURE,
          payload: { err }
        });

        return err;
      });
  };
};

export const payWithBalance = dealId => {
  return async (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    const idToken = await firebase.auth().currentUser.getIdToken(false);

    return axios
      .post(`${process.env.REACT_APP_FIREBASE_URL}/payWithBalance`, {
        idToken,
        dealId
      })
      .then(response => {
        dispatch({
          type: PAY_WITH_BALANCE_SUCCESS,
          payload: { ...response.data }
        });

        return response.data;
      })
      .catch(err => {
        dispatch({
          type: PAY_WITH_BALANCE_FAILURE,
          payload: { err }
        });

        return err;
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/paymentsActions.js